import { toZonedTime } from 'date-fns-tz'
import { TFunction } from 'i18next'
import React from 'react'

import { GuestPassVisit } from '@/api/clients/get-guest-pass-profile'
import { TableColumn } from '@/components/ui/table'
import { Typography } from '@/components/ui/typography'
import { DEFAULT_TZ } from '@/constants/date'
import { EMPTY_VALUE } from '@/constants/ui'
import { formatDateOnly, formatTimeOnly } from '@/utils/date'

export const formatPassesUsed = (count: number, t: TFunction<['clients']>): string =>
  t('clients:guestPasses.checkins.passesUsed', { count })

export const getColumns = (
  t: TFunction<['clients']>,
  timezone: string = DEFAULT_TZ,
): TableColumn<GuestPassVisit>[] => [
  {
    id: 'amenity',
    render: (visit) => visit.placeId?.name ?? EMPTY_VALUE,
    title: t('clients:guestPasses.checkins.columns.amenity'),
  },
  {
    id: 'passesUsed',
    render: (visit) => formatPassesUsed(visit.guestCount, t),
    title: t('clients:guestPasses.checkins.columns.passesUsed'),
  },
  {
    id: 'dateTime',
    render: (visit) => {
      const date = toZonedTime(new Date(visit.createdAt), timezone)
      return `${formatDateOnly(date)}\n${formatTimeOnly(date)}`
    },
    title: t('clients:guestPasses.checkins.columns.dateTime'),
    width: '20rem',
  },
]
